import React from "react";
import Simplebar, { Props } from "simplebar-react";
import css from "./Scrollbar.module.scss";
import { getClassName } from "@utils";

const Scrollbar: React.FC<Props> = ({ children, className, ...rest }) => {
  const attrs = {
    container: {
      className: getClassName(css.container, className),
      ...rest,
    },
  };

  return <Simplebar {...attrs.container}>{children}</Simplebar>;
};

export default Scrollbar;
